<template>
  <div class="grid-container">
    <div class="grid-x grid-margin-x">
      <transition name="slide" mode="out-in">
        <div class="cell small-12 large-4 large-offset-4 text-center" v-if="result !== 1">
          <p>Super, wybierz dowolną liczbę:</p>
          <input type="number" placeholder="Wybierz mądrze" v-model="userNumber" />
          <button class="button success" @click="checkWinner">To moja liczba!</button>
        </div>
      </transition>

      <div class="cell small-12 large-4 large-offset-4 text-center">
        <transition name="fade" mode="out-in">
          <div v-if="result === 1" key="1">
            <div class="callout success">
              <h5>{{ resultMsg }}</h5>
            </div>
            <button class="button success" @click="resetGame">Jeszcze raz, teraz wygram!</button>
          </div>
          <div class="callout alert" v-else-if="result === 2" key="2">
            <h5>{{ resultMsg }}</h5>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        userNumber: '',
        programNumber: 0,
        resultMsg: '',
        result: 0
      }
    },
    methods: {
      checkWinner() {
        if (this.userNumber === '') {
          this.result = 2;
          this.resultMsg = 'No, ale musisz jakąś podać!';
        } else {
          this.result = 1;
          this.programNumber = parseInt(this.userNumber) + (Math.floor(Math.random() * 10)) + 1;
          this.resultMsg = 'HA! Wygrałem, moja liczba to: ' + this.programNumber
        }
      },
      resetGame() {
        this.result = 0;
        this.userNumber = '';
        this.resultMsg = '';
      }
    }
  }


</script>


<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-enter-active, .slide-leave-active {
    transition: max-height .2s;
    max-height: 100px;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    max-height: 0;
  }
</style>
